import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'TextHighlight',
    standalone: false
})
export class TextHighlightPipe implements PipeTransform {
  transform(sourceString: string, highlightText: string) {
    try {
      if (highlightText === null) {
        return sourceString;
      }
      if (highlightText === '') {
        return sourceString;
      }
      if (sourceString === null) {
        return sourceString;
      }
      if (sourceString === '') {
        return sourceString;
      }
      if (sourceString == undefined) {
        return sourceString;
      }
      // Highlight each word of the query separately (and escape regex specials),
      // so multi-word / reordered queries like "doe john" still highlight "John" and "Doe".
      const tokens = String(highlightText)
        .trim()
        .split(/\s+/)
        .filter(t => t.length > 0)
        .map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (tokens.length === 0) {
        return sourceString;
      }
      const searchMask = '(' + tokens.join('|') + ')';
      const regEx = new RegExp(searchMask, 'gi');
      const replaceMask = '<b class=\'highlight-search\'>$1</b>';

      const res = sourceString.replace(regEx, replaceMask);

      return res;
    }
    catch (e) {
      return "";
    }
  }
}
